import {Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef} from "@angular/core";
import {Observable} from "rxjs";
import * as Communication from "../communication/index";
import {Router, ActivatedRoute} from "@angular/router";
import {Config} from "../../environments/environment";
import {NavigationService} from "../shared/common/NavigationEventService";
import {NavigationEvent} from "../shared/common/NavigationEvent";
import { Subscription } from 'rxjs';
import {Location} from "@angular/common";
import {ToolbarService} from "../shared/common/ToolbarEventService";
import {NotificationService} from "../shared/common/NotificationService";
import {ToolbarEventPageEnum, ToolbarEvent} from "../shared/common/ToolbarEvent";
import {Authorization} from "../shared/authorization/authorization.component";
import {TranslateService} from '@ngx-translate/core';
import {StripeLoaderService} from "../shared/common/StripeLoaderService";
//import AdyenCheckout from "@adyen/adyen-web";

declare var $:any;
declare var swal: any;
declare var $zopim: any;

//const AdyenWeb = require('adyen-web');

/**
 * This class represents the lazy loaded AccountComponent.
 */
@Component({
    selector: 'sd-upgrade',
    templateUrl: 'upgrade.component.html',
    styleUrls: ['upgrade.component.css'],
    providers: [Communication.JobsService, Communication.DocumentsService, Communication.RecipientRequestService, Communication.PlansService, Communication.PlansService, Communication.SubscriptionService, Communication.PaymentService],
    standalone: false
})
export class UpgradeComponent implements OnInit, OnDestroy {

  timerSubscription:Subscription=null;
  subscriptions:Subscription[] = [];

  theUser:Communication.UsersService;
  returnUrl:string;
  userMetadata = {};
  name:string="";
  title:string="";
  company:string="";
  country:string="";
  address:string="";
  language:string="";
  languages:any = [];
  thePlanInfo:Communication.PlanInfo;
  thePaymentForm:Communication.PaymentForm;
  showUpgradePlan:boolean=false;
  isMailSent:boolean=false;
  paymentModalVisibility:boolean=false;
  selectedPlan:any={};
  paymentAction:string="";
  paymentPeriod='Monthly';
  modalId:string=""; // to bind data-target register subs. payment and upgrade modals
  currentPlan:string="";

  //upgrade plan variables
  currentPrice:string="";
  upgradePrice:string="";
  remainPrice:string="";

  paymentMethod:string = Config.PAYMENT_METHOD;

  paymentGroup:string = "Individual";
  thePayment:any={};

  paymentStatusAdyen:string;
  paymentRefusalReasonAdyen:string;
  dropin:any;

  paypointResponse:{
    Lang:string,
    MerchantCode:string,
    MerchantUser:string,
    TrnKey:string,
    Amount:string,
    Currency:string,
    Description:string,
    MerchantTrnId:string,
    RedirectUri:string
  } = {
    Lang:"",
    MerchantCode:"",
    MerchantUser:"",
    TrnKey:"",
    Amount:"",
    Currency:"",
    Description:"",
    MerchantTrnId:"",
    RedirectUri:""
  };

  discountAmount:string;
  isCouponValid:boolean;

  // Stripe
  stripe: any = null;
  stripeElements: any = null;
  stripePaymentElement: any = null;
  stripeClientSecret: string = "";
  stripeSubscriptionId: string = "";
  stripeLoading: boolean = false;

  constructor(private jobsApi:Communication.JobsService,
              private documentsApi:Communication.DocumentsService,
              private usersApi:Communication.UsersService,
              private plansApi:Communication.PlansService,
              private subscriptionsApi:Communication.SubscriptionService,
              private paymentApi: Communication.PaymentService,
              private activatedRoute:ActivatedRoute,
              private router:Router,
              private navigationService:NavigationService,
              private toolbarService: ToolbarService,
              private location:Location,
              public authorization: Authorization,
              private notificationService: NotificationService,
              public translate: TranslateService,
              private stripeLoader: StripeLoaderService,
              private cdr: ChangeDetectorRef)
  {






  }

  ngOnInit() {

    let node2 = document.createElement('link');
    node2.rel = "stylesheet";
    node2.href = "https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/4.3.0/adyen.css";
    node2.crossOrigin = "anonymous";
    node2.integrity = "sha384-5CDvDZiVPuf+3ZID0lh0aaUHAeky3/ACF1YAKzPbn3GEmzWgO53gP6stiYHWIdpB";
    document.getElementsByTagName('head')[0].appendChild(node2);

    // Load Stripe.js conditionally when STRIPE is selected
    if (this.paymentMethod == "STRIPE" && Config.STRIPE_PUBLISHABLE_KEY) {
      this.stripeLoader.loadStripe().then(stripe => {
        this.stripe = stripe;
      }).catch(() => {
        this.notificationService.displayError({ error: this.translate.instant('Failed to load payment system. Please refresh the page.') });
      });
    }

    if (!this.authorization.authenticated()) {
      this.router.navigate(['/']);
    } else {
      this.initPayment();
      this.setActiveModal();
      this.showUpgradePlans();
      this.toolbarService.action(new ToolbarEvent(ToolbarEventPageEnum.UPGRADE, "", null, "", "", "", "", "", ""));
    }
  }

  getPaymentMethods(price:string){

    let self = this;

    this.subscriptions.push(
      this.paymentApi.paymentsMethodsPost(
        price,
        "NL",
        "EUR",
        "nl-NL",
        this.authorization.getAccessToken(),
      ).subscribe(
        (response:any) => {

          const configuration:any = {
            paymentMethodsResponse: response,
            clientKey: Config.ADYEN_CLIENT_KEY,
            locale: "en-US",
            environment: "test",
            paymentMethodsConfiguration: {
              card: {
                hasHolderName: true,
                holderNameRequired: true,
                enableStoreDetails: false,
                hideCVC: false,
                name: 'Credit or debit card',
                amount: {
                  value: price,
                  currency: 'EUR',
                },
              }
            },
            onSubmit: (state:any, dropin:any) => {

              if(self.checkThePayment()){

                let stateStringOriginal = state.data.paymentMethod;
                let stateString = JSON.stringify(stateStringOriginal);
                for (var i = 0; i < stateString.length; i++) {
                  if(stateString.charAt(i) == "+"){
                    stateString = stateString.replace("+","%2B")
                  }
                }

                if(this.paymentAction == "upgrade"){
                  this.subscriptions.push(
                    this.subscriptionsApi.subscriptionsUpgradePut(
                      this.authorization.getAccessToken(),
                      this.selectedPlan.name,
                      this.selectedPlan.period,
                      this.upgradePrice,
                      stateStringOriginal.holderName,"0000000000000000",null,null,null,
                      this.thePayment.address,
                      this.thePayment.zipCode,
                      this.thePayment.city,
                      this.thePayment.province,
                      "NL",
                      this.thePayment.company.taxOffice,
                      this.thePayment.company.taxNo,
                      this.paymentGroup,
                      this.thePayment.company.title,
                      this.thePayment.individual.name,
                      this.thePayment.individual.citizenId,
                      this.isCouponValid ? this.thePayment.discountCoupon : null,
                      stateString
                    ).subscribe(
                      (response:any) => {

                        if(response.response.action != null){
                          console.log(response.response.action)
                          dropin.handleAction(response.response.action);
                        } else {
                          this.paymentStatusAdyen = response.response.resultCode || response.response.message;
                          this.paymentRefusalReasonAdyen = response.response.refusalReason || "";
                          $("#modal_payment_adyen").modal("hide");

                          if(response.response.resultCode != "Authorised"){
                            setTimeout(function(){ $("#modal_after_payment_adyen").modal("show"); },1000)
                          } else {
                            this.authorization.setUserAccount(response.subscription, this.authorization.userAccount.language);
                            setTimeout(() => {
                              this.router.navigate(['/result'], { queryParams: { action: this.paymentAction, plan: this.selectedPlan.name, period: this.selectedPlan.period}});
                            }, 25);
                            console.log(response);
                          }
                        }
                      },
                      (err:any) => {
                        console.log(err);
                        this.notificationService.displayError(err);
                      }
                    )
                  )
                } else if(this.paymentAction == "update") {
                  this.subscriptionsApi.subscriptionsPut(
                    this.authorization.getAccessToken(),
                    stateStringOriginal.holderName,"0000000000000000",null,null,null,
                    this.thePayment.address,
                    this.thePayment.zipCode,
                    this.thePayment.city,
                    this.thePayment.province,
                    "NL",
                    this.thePayment.company.taxOffice,
                    this.thePayment.company.taxNo,
                    this.paymentGroup,
                    this.thePayment.company.title,
                    this.thePayment.individual.name,
                    this.thePayment.individual.citizenId,
                    stateString
                  ).subscribe(
                    (response:any) => {

                      if(response.response.action != null){
                        console.log(response.response.action)
                        dropin.handleAction(response.response.action);
                      } else {
                        this.paymentStatusAdyen = response.response.resultCode || response.response.message;
                        this.paymentRefusalReasonAdyen = response.response.refusalReason || "";
                        $("#modal_payment_adyen").modal("hide");

                        if(response.response.resultCode != "Authorised"){
                          setTimeout(function(){ $("#modal_after_payment_adyen").modal("show"); },1000)
                        } else {
                          setTimeout(() => {
                            this.router.navigate(['/result'], { queryParams: { action: this.paymentAction, plan: this.selectedPlan.name, period: this.selectedPlan.period}});
                          }, 25);
                          console.log(response);
                        }
                      }
                    },
                    (err:any) => {
                      console.log(err);
                      this.notificationService.displayError(err);
                    }
                  );
                }

              } else {
                this.notificationService.showPleaseFillTheForm();
              }

              // Your function calling your server to make the `/payments` request
              // makePayment(state.data)
              //   .then((response:any) => {
              //     if (response.action) {
              //       // Drop-in handles the action object from the /payments response
              //       dropin.handleAction(response.action);
              //     } else {
              //       // Your function to show the final result to the shopper
              //       showFinalResult(response);
              //     }
              //   })
              //   .catch(error => {
              //     throw Error(error);
              //   });
            },
            onAdditionalDetails: (state:any, dropin:any) => {
              // Your function calling your server to make a `/payments/details` request
              // makeDetailsCall(state.data)
              //   .then((response:any) => {
              //     if (response.action) {
              //       // Drop-in handles the action object from the /payments response
              //       dropin.handleAction(response.action);
              //     } else {
              //       // Your function to show the final result to the shopper
              //       showFinalResult(response);
              //     }
              //   })
              //   .catch((error:any) => {
              //     throw Error(error);
              //   });
            }
          };

          //const checkout = new AdyenCheckout(configuration);
          //this.dropin = checkout.create('dropin').mount('#dropin-container');
        },
        (error:any) => {
          console.log(error);
        }
      )
    )
  }

  showUpgradePlans(){
    this.subscriptions.push(this.plansApi.plansGet(this.authorization.getAccessToken()).subscribe(
      (planInfo:Communication.PlanInfo) => {
        this.thePlanInfo = planInfo;
      }, //Bind to view
      err => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
      }
    ));
  }

  setActiveModal(){
    this.currentPlan = this.authorization.userAccount.subscription.plan.name;

    if(this.currentPlan !== "TRIAL" && this.currentPlan !== "FREE") {
      this.modalId = "";
    }else{
      if(this.paymentMethod == "IYZICO"){
        this.modalId = "modal_payment";
      } else if (this.paymentMethod == "ADYEN"){
        this.modalId = "modal_payment_adyen";
      } else if(this.paymentMethod == "PAYPOINT"){
        this.modalId = "modal_payment_paypoint";
      } else if(this.paymentMethod == "STRIPE"){
        this.modalId = "modal_payment_stripe";
      }
    }
  }

  getPaymentForm(planName:string, planPeriod:string, planPrice:string){

    this.selectedPlan = { name:planName, period: planPeriod, price: planPrice };
    this.setActiveModal();

    if(this.paymentMethod == "IYZICO"){

      if(this.currentPlan !== "TRIAL" && this.currentPlan !== "FREE") {
        console.log("change plan To: ", planName + " - "+ planPeriod);

        this.subscriptions.push(this.plansApi.userPlansIdPeriodGet(this.authorization.getAccessToken(), this.selectedPlan.name, this.selectedPlan.period).subscribe(
          (response:Communication.PlanPrice) => {
            console.log(response);

            if(response.upgradePrice != "-1.0") {
              this.paymentAction = "";

              //trigger again to open modal
              //document.getElementById("openModal").click();
              $("#modal_upgrade").modal();

              this.upgradePrice = response.upgradePrice;
              this.currentPrice = response.currentPrice;
              this.remainPrice = (Number(this.currentPrice) - Number(this.upgradePrice)).toString();

              /*
              let coupon:any = this.authorization.userAccount.subscription.coupon;
              if(coupon !== null && coupon.code != ""){
                this.getCoupon(coupon.code)
              }*/

            }else{
              this.notificationService.selectedPlanNotSuitToUpgrade();
            }

          }, //Bind to view
          (err:any) => {
            // Log errors if any
            console.log(err);
            this.notificationService.displayError(err);
          }
        ));

      }else{
        console.log("upgrade plan To: ", planName + " - "+ planPeriod);

        this.paymentModalVisibility = true;
        this.paymentAction = "upgrade";
      }

    } else if(this.paymentMethod == "ADYEN") {

      this.subscriptions.push(
        this.plansApi.userPlansIdPeriodGet(
          this.authorization.getAccessToken(),
          planName,
          planPeriod
        ).subscribe(
          (response:Communication.PlanPrice) => {
            console.log(response);
            if(response.upgradePrice != "-1.0") {
              this.upgradePrice = response.upgradePrice;
              this.currentPrice = response.currentPrice;
              this.remainPrice = (Number(this.currentPrice) - Number(this.upgradePrice)).toString();

              if(this.currentPlan !== "TRIAL" && this.currentPlan !== "FREE"){
                  this.paymentAction = "update";

                  $("#modal_upgrade").modal();

                  this.upgradePrice = response.upgradePrice;
                  this.currentPrice = response.currentPrice;
                  this.remainPrice = (Number(this.currentPrice) - Number(this.upgradePrice)).toString();

              } else {
                this.paymentAction = "upgrade"
                this.getPaymentMethods((+this.upgradePrice*100).toString());
              }

            }else{
              this.notificationService.selectedPlanNotSuitToUpgrade();
            }
          },
          (error:any) => {
            console.log(error);
          }
        )
      );
    } else if(this.paymentMethod == "PAYPOINT"){

      this.subscriptions.push(
        this.plansApi.userPlansIdPeriodGet(
          this.authorization.getAccessToken(),
          planName,
          planPeriod
        ).subscribe(
          (response:Communication.PlanPrice) => {
            console.log(response);
            if(response.upgradePrice != "-1.0") {
              this.upgradePrice = response.upgradePrice;
              this.currentPrice = response.currentPrice;
              this.remainPrice = (Number(this.currentPrice) - Number(this.upgradePrice)).toString();

              if(this.currentPlan !== "TRIAL" && this.currentPlan !== "FREE"){
                  this.paymentAction = "update";

                  $("#modal_upgrade").modal();

                  this.upgradePrice = response.upgradePrice;
                  this.currentPrice = response.currentPrice;
                  this.remainPrice = (Number(this.currentPrice) - Number(this.upgradePrice)).toString();

              } else {
                this.paymentAction = "upgrade"
              }

            }else{
              this.notificationService.selectedPlanNotSuitToUpgrade();
            }
          },
          (error:any) => {
            console.log(error);
          }
        )
      );
    } else if(this.paymentMethod == "STRIPE"){

      this.subscriptions.push(
        this.plansApi.userPlansIdPeriodGet(
          this.authorization.getAccessToken(),
          planName,
          planPeriod
        ).subscribe(
          (response:Communication.PlanPrice) => {
            console.log(response);
            if(response.upgradePrice != "-1.0") {
              this.upgradePrice = response.upgradePrice;
              this.currentPrice = response.currentPrice;
              this.remainPrice = (Number(this.currentPrice) - Number(this.upgradePrice)).toString();

              if(this.currentPlan !== "TRIAL" && this.currentPlan !== "FREE"){
                this.paymentAction = "update";
                $("#modal_upgrade").modal();
              } else {
                this.paymentAction = "upgrade";
              }
            } else {
              this.notificationService.selectedPlanNotSuitToUpgrade();
            }
          },
          (error:any) => {
            console.log(error);
          }
        )
      );
    }

    console.log("planName "+ planName + " period  " + planPeriod + " price  " + planPrice);
  }

  checkThePayment(){
    if(this.paymentGroup == "Individual"){
      if(
        this.thePayment.individual.name == null
        || this.thePayment.individual.name == ""
        || this.thePayment.individual.citizenId == null
        || this.thePayment.individual.citizenId == ""
      ){
        return false;
      }
    } else if(this.paymentGroup == "Company"){
      if(
        this.thePayment.company.title == null
        || this.thePayment.company.title == ""
        || this.thePayment.company.taxOffice == null
        || this.thePayment.company.taxOffice == ""
        || this.thePayment.company.taxNo == null
        || this.thePayment.company.taxNo == ""
      ){
        return false;
      }
    }
    if(
      this.thePayment.address == ""
      || this.thePayment.address == null
      || this.thePayment.city == ""
      || this.thePayment.city == null
      || this.thePayment.province == ""
      || this.thePayment.province == null
      || this.thePayment.zipCode == ""
      || this.thePayment.zipCode == null
    ){
      return false;
    }
    return true;
  }

  useAnotherCard(){
    this.paymentAction = "update";
    if(this.paymentMethod == "IYZICO"){
      this.selectedPlan = null;
      this.paymentModalVisibility = true;
    } else if(this.paymentMethod == "ADYEN") {
      $("#modal_upgrade").modal("hide");
      this.getPaymentMethods("100");
      setTimeout(function(){
        $("#modal_payment_adyen").modal();
      },1000);
    }
  }

  renewSubcriptionPaypoint(){
    this.subscriptions.push(
      this.paymentApi.paymentsPaypointRenewPost(
        this.authorization.getAccessToken()
      ).subscribe(
        (response:any) => {
          console.log("response ",response);
          this.paypointResponse = response.response;
          setTimeout(function(){
            $("#paypointForm").submit();
          },1000);
        },
        (error:any) => {
          console.log(error);
        }
      )
    )
  }

  approveNewPlan(){
    this.subscriptionsApi.subscriptionsPlanPut(this.authorization.getAccessToken(), this.selectedPlan.name, this.selectedPlan.period).subscribe(
      (response:any) => {
        console.log("response ", response);

        if(this.paymentMethod == "PAYPOINT"){
          this.paypointResponse = response;
          setTimeout(function(){
            $("#paypointForm").submit();
          },1000);
        } else {
          this.authorization.setUserAccount(response.subscription, this.authorization.userAccount.language);
          setTimeout(() => {
            this.router.navigate(['/result'], { queryParams: { action: "upgrade", plan: this.selectedPlan.name, period: this.selectedPlan.period}});
          }, 25);
        }

      },
      (err: any) => {
        console.log(err);
        this.notificationService.displayError(err);
      });
  }

  initPayment(){
    let company = { title: "",  taxOffice: "",  taxNo:  ""  };
    let individual = { name: "", citizenId: "" };

    this.thePayment = {
      company: company ,
      individual: individual,
      address: "",
      city: "",
      province: "",
      zipCode: "",
      discountCoupon: ""
    };
  }

  paypointRegisterTransaction(){
    if(this.checkThePayment()){
      this.subscriptions.push(
        this.subscriptionsApi.subscriptionsUpgradePut(
          this.authorization.getAccessToken(),
          this.selectedPlan.name,
          this.selectedPlan.period,
          this.upgradePrice,
          null,"0000000000000000",null,null,null,
          this.thePayment.address,
          this.thePayment.zipCode,
          this.thePayment.city,
          this.thePayment.province,
          "CY",
          this.thePayment.company.taxOffice,
          this.thePayment.company.taxNo,
          this.paymentGroup,
          this.thePayment.company.title,
          this.thePayment.individual.name,
          this.thePayment.individual.citizenId,
          this.isCouponValid ? this.thePayment.discountCoupon : null,
          null
        ).subscribe(
          (response:any) => {
            console.log("response ", response);
            if(response.response == null){
              this.notificationService.tryAgainLater();
            } else {
              this.paypointResponse = response.response;
              setTimeout(function(){
                $("#paypointForm").submit();
              },1000)
            }
          },
          (error:any) => {
            console.log(error);
          }
        )
      )
    } else {
      this.notificationService.showPleaseFillTheForm();
    }
  }

  checkCoupon(discountCoupon:string, isDiscountCouponValid:boolean){
    if (isDiscountCouponValid) {
      console.log("DiscountCoupon is valid.");
      if(discountCoupon != '' && discountCoupon != null){
        this.thePayment.discountCoupon = discountCoupon;
        this.getCoupon();
      }
    } else {
      this.isCouponValid = false;
    }
  }

  getCoupon(){

    this.subscriptionsApi.couponsGet(this.authorization.getAccessToken(), this.thePayment.discountCoupon).subscribe(
      (response:any) => {

        console.log("response ", response);

        this.isCouponValid = true;
        this.discountAmount = response.discount;
        let subscription:any = this.authorization.userAccount.subscription;
        let dayTime:number = 24*60*60*1000;

        //whether couponCode is valid or not
        if(Number(response.usageExpiry) > Date.now() && (
          Number(response.discountExpiryDate) >= Number(subscription.planExpiryDate) ||
          Number(subscription.couponStartDate) + Number(response.discountExpiryPeriod) * dayTime >= Number(subscription.planExpiryDate)))
        {
          let multiplier:number = ((1 - response.discount/100));
          this.remainPrice = (multiplier * Number(this.remainPrice)).toString();
          this.upgradePrice = (multiplier * Number(this.upgradePrice)).toString();
          this.currentPrice = (multiplier * Number(this.currentPrice)).toString();
          $("#dropin-container").remove();
          $('#adyen-container').append('<div id="dropin-container"></div>');
          this.getPaymentMethods((+this.upgradePrice*100).toString());
        }

      }, //Bind to view
      (err:any) => {
        // Log errors if any
        console.log(err);
        this.notificationService.displayError(err);
        this.isCouponValid = false;
      });
  }

  // Stripe payment methods
  stripeSubmitPayment(){
    if(this.checkThePayment()){
      this.stripeLoading = true;
      this.subscriptions.push(
        this.subscriptionsApi.subscriptionsUpgradePut(
          this.authorization.getAccessToken(),
          this.selectedPlan.name,
          this.selectedPlan.period,
          this.upgradePrice,
          null,"0000000000000000",null,null,null,
          this.thePayment.address,
          this.thePayment.zipCode,
          this.thePayment.city,
          this.thePayment.province,
          Config.BILLING_COUNTRY,
          this.thePayment.company.taxOffice,
          this.thePayment.company.taxNo,
          this.paymentGroup,
          this.thePayment.company.title,
          this.thePayment.individual.name,
          this.thePayment.individual.citizenId,
          this.isCouponValid ? this.thePayment.discountCoupon : null,
          null
        ).subscribe(
          (response:any) => {
            console.log("Stripe upgrade response: ", response);
            if(response.response == null){
              this.stripeLoading = false;
              this.notificationService.showStripePaymentError(
                this.translate.instant('Your payment was not successful. Please try again.')
              );
            } else {
              this.stripeClientSecret = response.response.clientSecret;
              this.stripeSubscriptionId = response.response.subscriptionId;
              this.stripeLoading = false;
              this.mountStripePaymentElement();
            }
          },
          (error:any) => {
            this.stripeLoading = false;
            console.log(error);
            this.notificationService.displayError(error);
          }
        )
      )
    } else {
      this.notificationService.showPleaseFillTheForm();
    }
  }

  mountStripePaymentElement(){
    if(!this.stripe){
      console.error("Stripe.js not loaded");
      return;
    }

    this.stripeElements = this.stripe.elements({
      clientSecret: this.stripeClientSecret
    });

    this.stripePaymentElement = this.stripeElements.create('payment');

    this.cdr.detectChanges();
    this.stripePaymentElement.mount('#stripe-payment-element');
  }

  async stripeConfirmPayment(){
    if(!this.stripe || !this.stripeElements){
      return;
    }

    this.stripeLoading = true;

    const returnUrl = Config.WEB_APP_URL + '/result?action=' + this.paymentAction
      + '&plan=' + this.selectedPlan.name
      + '&period=' + this.selectedPlan.period;

    const {error} = await this.stripe.confirmPayment({
      elements: this.stripeElements,
      confirmParams: {
        return_url: returnUrl
      }
    });

    if(error){
      this.stripeLoading = false;
      console.log("Stripe payment error:", error);

      if(error.type === 'card_error' || error.type === 'validation_error'){
        const errorMessage = error.message || this.translate.instant('Your payment was not successful. Please try again.');
        this.notificationService.showStripePaymentError(errorMessage);
      } else {
        this.notificationService.showStripePaymentError(
          this.translate.instant('Your payment was not successful. Please try again.')
        );
      }
    }
    // If no error, user is redirected to return_url by Stripe
  }

  ngOnDestroy() {
    $('.modal-backdrop').remove();

    this.subscriptions.forEach(
      (s:Subscription) => s.unsubscribe()
    );
    if (this.timerSubscription != null) {
      this.timerSubscription.unsubscribe();
    }
  }

}
